export default __webpack_public_path__ + "496120331af4687d6305820e544648e8.png";